<template>
  <div id="app">
    <el-container style="height: 100%;">
        <router-view/>
    </el-container>
  </div>
</template>

<script>
  import {apiLogout} from '@/api/login'
  import {mapState, mapMutations} from 'vuex'
  import Cookies from 'js-cookie'
  import util from '@/base/js/util'

  export default {
    name: 'App',
    data() {
      return {
        account_list: [],
        account_img: '',
        default_img: require('@/assets/logo.png')
      }
    },
    computed: {
      ...mapState({
        uid: state => state.userInfo.uid,
        username: state => state.userInfo.username,
      })
    },
    created() {
      // this.$nextTick(() => {
      //   this._getUserInfo()
      // })
    },
    methods: {
      //跳转首页(用户未登录时，主页路由未加载，点击不跳转)
      goToIndex(){
        if (Cookies.get('token')){
          this.$router.push({
            path: '/'
          })
        }
      },
      //获取用户信息
      _getUserInfo() {
        return new Promise((resolve, reject) => {
          if (!Cookies.get('token')) return
          getUserInfo().then(res => {
            if (res.resultCode === '0') {
              this.updateUserInfo({
                ...res.result,
                token: Cookies.get('token')
              })
              resolve(res.result)
            } else {
              Cookies.set('PHPSESSION', '')
              Cookies.set('token', '')
              this.$router.push('/login')
            }
          })
        })
      },
      //登出
      logout() {
        apiLogout().then(res => {
          if (res.resultCode === '0') {
            this.$message.success('注销成功')
            Cookies.set('token','')
            util.removeSession('userInfo')
            setTimeout(function () {
              location.reload()
            }, 500)
          } else {
            this.$message.error(res.errorMsg)
          }
        })
      },
      ...mapMutations({
        updateUserInfo: 'updateUserInfo'
      })
    }
  }
</script>

<style lang="less">
  @import "./base/style/reset";

  html,body{
    height: 100%;
  }

  body {
    min-width: 1300px;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  #app{
    height: 100%;
  }
  /*路由切换动效*/
  .router-enter-active{
    animation: routerOut .5s;
  }
  .router-leave-active {
    animation: routerOut .5s reverse;
  }

  @keyframes routerOut {
    0%{
      transform: translateX(5px);
      opacity: 0;
    }
    100%{
      transform: translateX(0px);
      opacity: 1;
    }
  }


</style>
